export default "__VITE_ASSET__9VXtU11n__"